module.exports = __webpack_public_path__ + "img/malla ondulada.8c8a3b9b.jpg";